// Change Checklist 页面 Memo是否打勾
export enum ChangeCheckMemoStatus {
  // 不打勾
  NotChecked = 0,
  // 打勾
  Checked = 1,
}
